import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { AnalyticsService } from '@/app/service';

export interface UseAnalyticsOptions {
  trackPageViews?: boolean;
  userId?: string | null;
}

export function useAnalytics(options: UseAnalyticsOptions = {}) {
  const { trackPageViews = true, userId } = options;
  const pathname = usePathname();
  const previousPathname = useRef<string | null>(null);

  // Set user ID when it changes
  useEffect(() => {
    if (userId !== undefined) {
      AnalyticsService.setUserId(userId);
    }
  }, [userId]);

  // Track page views on route changes
  useEffect(() => {
    if (trackPageViews && pathname && pathname !== previousPathname.current) {
      previousPathname.current = pathname;
      AnalyticsService.trackPageView(pathname);
    }
  }, [pathname, trackPageViews]);

  // Return methods for manual tracking
  return {
    trackEvent: AnalyticsService.trackEvent,
    trackCustomEvent: AnalyticsService.trackCustomEvent,
    trackPageView: AnalyticsService.trackPageView,
    setUserId: AnalyticsService.setUserId,
  };
}
